import React, { useEffect } from 'react';
import style from './SafeAreaContainer.module.css';
import { Capacitor } from '@capacitor/core';
import { SafeArea } from 'capacitor-plugin-safe-area';
import { useLocation } from 'react-router-dom';
import { cl } from 'lincd/utils/ClassNames';
export const SafeAreaContainer = ({ children, color, resetTop = false, resetBottom = false, fullScreenRoutes, }) => {
    /**
     * apply safearea for ios and android
     */
    useEffect(() => {
        if (Capacitor.isNativePlatform()) {
            SafeArea.getSafeAreaInsets().then(({ insets }) => {
                for (const [key, value] of Object.entries(insets)) {
                    document.documentElement.style.setProperty(`--safe-area-${key}`, `${value}px`);
                }
            });
        }
    }, []);
    let location = useLocation();
    let backgroundColor = color;
    if (fullScreenRoutes) {
        const isFullScreen = fullScreenRoutes.some((route) => location.pathname.startsWith(route));
        backgroundColor = isFullScreen ? 'transparent' : color;
    }
    // check has color
    const styles = {};
    if (backgroundColor) {
        styles['backgroundColor'] = backgroundColor;
    }
    return (React.createElement("div", { className: cl(style.root, resetTop && style.resetTop, resetBottom && style.resetBottom) },
        !resetTop && (React.createElement("div", { className: cl(style.safearea, style['top']), style: styles })),
        React.createElement("div", null, children),
        !resetBottom && (React.createElement("div", { className: cl(style.safearea, style['bottom']), style: styles }))));
};
//# sourceMappingURL=SafeAreaContainer.js.map